import { render, staticRenderFns } from "./BaseLayout.vue?vue&type=template&id=23083b3e&"
import script from "./BaseLayout.ts?vue&type=script&lang=js&"
export * from "./BaseLayout.ts?vue&type=script&lang=js&"
import style0 from "./BaseLayout.vue?vue&type=style&index=0&id=23083b3e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports